module.exports = __webpack_public_path__ + "img/dog.18432c50.png";